import { Button } from "@acdc2/ui/components/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@acdc2/ui/components/popover";
import { useState } from "react";
import { Icon } from "@mdi/react";
import { mdiUnfoldMoreHorizontal } from "@mdi/js";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandList,
} from "@acdc2/ui/components/command";
import { useTranslation } from "react-i18next";
import { ExporterType } from "../client/generated";
import { DocumentExportCommandItem } from "./DocumentExportCommandItem";

type Props = {
  value: ExporterType | undefined;
  onSelect: (exporterType: ExporterType) => void;
};

export function DocumentExportCombobox({ value, onSelect }: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleSelect = (exporterType: ExporterType) => {
    setOpen(false);
    onSelect(exporterType);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="flex-1 justify-between"
        >
          {value ?? t("DocumentExportCombobox.label")}
          <Icon path={mdiUnfoldMoreHorizontal} size={1} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Command>
          <CommandInput placeholder={t("DocumentExportCombobox.input")} />
          <CommandList>
            <CommandEmpty>
              {t("DocumentExportCombobox.placeholder")}
            </CommandEmpty>
            <CommandGroup heading={t("DocumentExportCombobox.groups.docx")}>
              <DocumentExportCommandItem
                exporterType={ExporterType.Docx}
                isSelected={value === ExporterType.Docx}
                onSelect={handleSelect}
              />
            </CommandGroup>
            <CommandGroup heading={t("DocumentExportCombobox.groups.latex")}>
              <DocumentExportCommandItem
                exporterType={ExporterType.Latex}
                isSelected={value === ExporterType.Latex}
                onSelect={handleSelect}
              />
            </CommandGroup>
            <CommandGroup heading={t("DocumentExportCombobox.groups.pdf")}>
              <DocumentExportCommandItem
                exporterType={ExporterType.Pdf}
                isSelected={value === ExporterType.Pdf}
                onSelect={handleSelect}
              />
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
